import { AnimatePresence, motion } from 'framer-motion';

import { Photo } from '../Photo/Photo';
import { BgVideo } from '../BgVideo/BgVideo';

import styles from './Message.module.css';
import logo from '../../assets/images/logo.png';
import { useGetParams } from '../../hooks/useGetParams';

const Message = ({ currentMessage, message, rotateSign, duration }) => {
  const durationSec = duration / 1000;
  const endpointStart = 0.33;
  const exitDuration = 0.18 * durationSec;
  const allStartDuration = durationSec - exitDuration;
  const startDutation = allStartDuration * endpointStart;

  const { qrCode1, qrCode2 } = useGetParams();

  const sizeQR = '24.7';

  return (
    <div className={styles.wrapper}>
      <div className={styles.advtBlock}>
        <motion.div
          className={styles.logoBlock}
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
        >
          <img src={logo} alt="" className={styles.logo} />
        </motion.div>

        <div className={styles.qrsWrapper}>
          {qrCode1 && (
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ duration: 0.6 }}
              className={styles.qrCode}
            >
              <img
                src={qrCode1}
                alt="QR"
                style={{
                  height: `${sizeQR}rem`,
                  width: `${sizeQR}rem`,
                }}
              />
            </motion.div>
          )}
          {qrCode2 && (
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ duration: 0.6, delay: 0.5 }}
              className={styles.qrCode}
            >
              <img
                src={qrCode2}
                alt="QR"
                style={{
                  width: `${sizeQR}rem`,
                  height: `${sizeQR}rem`,
                }}
              />
            </motion.div>
          )}
        </div>
      </div>

      <AnimatePresence mode="wait">
        <motion.div
          key={currentMessage.id}
          initial={{ scale: 0 }}
          animate={{
            scale: [0, 1, 0.9],
            transition: {
              duration: allStartDuration,
              times: [0, endpointStart, 1],
            },
          }}
          exit={{
            y: '-100vh',
            transition: {
              duration: exitDuration,
            },
          }}
          className={styles.photoBlock}
        >
          <Photo
            message={message}
            rotateSign={rotateSign}
            startDutation={startDutation}
          />
        </motion.div>
      </AnimatePresence>

      <BgVideo />
    </div>
  );
};

export default Message;
